<template>
	<CreationWizardListItemRow class="placement-row" :icon="icon">
		<template #title>
			<PlacementRowContent :entityName="addOnType" :itemName="itemName" />
		</template>
	</CreationWizardListItemRow>
</template>

<script>
import PlacementService from '@/utils/placement-service';
import CreationWizardListItemRow from './CreationWizardListItemRow.vue';
import PlacementRowContent from './PlacementRowContent.vue';
export default {
	name: 'PlacementRow',
	props: {
		placement: { type: Object },
		elementType: { type: String },
	},
	components: { CreationWizardListItemRow, PlacementRowContent },
	computed: {
		icon() {
			return PlacementService.getAddOnIcon(this.placement, this.elementType);
		},
		itemName() {
			return PlacementService.getFullItemName(this.placement);
		},
		addOnType() {
			return PlacementService.getAddOnType(this.placement, this.elementType);
		},
	},
};
</script>

<style lang="scss" scoped></style>
